module.exports = __webpack_public_path__ + "img/stick_hiver_luge.f769f8e3.svg";